// AppFrame — browser-window chrome for projectType='app' and 'website'.
// Shows a URL bar with dot controls, 16:10 aspect, primary-brand accent.
// The viewport area is where thumbnails inset; a faint globe glyph shows
// for empty-content state.

export const AppFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  round: 'inherit',
  overflow: 'hidden',
  position: 'relative',

  // Browser chrome header strip
  Chrome: {
    flexShrink: '0',
    flow: 'x',
    align: 'center',
    gap: 'V',
    padding: 'V A',
    borderBottom: '1px solid',
    borderColor: 'white.08',
    background: 'gray1.35',
    height: 'B',

    // Traffic-light dots
    Dots: {
      flow: 'x',
      gap: 'W',
      align: 'center',
      Dot_1: {
        width: 'W',
        height: 'W',
        round: '50%',
        background: 'red.85',
        flexShrink: '0'
      },
      Dot_2: {
        width: 'W',
        height: 'W',
        round: '50%',
        background: 'yellow.85',
        flexShrink: '0'
      },
      Dot_3: {
        width: 'W',
        height: 'W',
        round: '50%',
        background: 'green.85',
        flexShrink: '0'
      }
    },

    // URL bar — decorative placeholder bar
    UrlBar: {
      flexGrow: '1',
      height: 'Y',
      round: 'Z',
      background: 'white.07',
      maxWidth: 'F',
      margin: '0 auto'
    },

    // Globe indicator dot
    GlobeIcon: {
      width: 'Y',
      height: 'Y',
      round: '50%',
      background: 'blue.45',
      flexShrink: '0'
    }
  },

  // Viewport — thumbnail slots here, empty-state shows globe glyph
  Viewport: {
    flexGrow: '1',
    position: 'relative',
    overflow: 'hidden',
    background: 'black.2',

    EmptyState: {
      if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
      position: 'absolute',
      inset: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'Y',
      pointerEvents: 'none',

      Glyph: {
        width: 'B',
        height: 'B',
        opacity: '0.18',
        fontSize: 'B',
        color: 'blue',
        textAlign: 'center',
        lineHeight: '1',
        text: '⊕'
      },
      Hint: {
        tag: 'span',
        text: 'Web app',
        fontSize: 'Z1',
        color: 'white.22',
        fontStyle: 'italic'
      }
    }
  },

  // Left-border accent (primary blue)
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'blue',
    opacity: '0.7',
    pointerEvents: 'none'
  }
}
